import * as React from "react";
function SvgIcUnlink(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.348 4.764l-.725-.194-.776 2.9.723.192.777-2.898zM18.442 15.207L15.1 11.863a2.283 2.283 0 00-1.57-.62v.75c.39-.002.763.144 1.048.408l3.321 3.324a1.542 1.542 0 01-2.162 2.193l-3.221-3.223a1.544 1.544 0 01-.527-1.16h-.75a2.275 2.275 0 00.764 1.707l3.217 3.218a2.291 2.291 0 003.222-3.253zM11.202 7.965L7.861 4.622A2.291 2.291 0 104.765 8l3.216 3.218c.42.383.97.595 1.54.595v-.75a1.53 1.53 0 01-1.023-.387L5.277 7.453A1.542 1.542 0 117.339 5.16l3.32 3.322c.26.284.403.654.403 1.038h.75c0-.576-.218-1.132-.61-1.555zM15.788 6.783l2.123-2.119.53.531-2.122 2.12-.53-.532zM15.381 8.558l2.898-.777.194.725-2.898.777-.194-.725zM7.767 18.29l.773-2.9.725.194-.774 2.9-.724-.194zM4.672 17.861l2.123-2.119.53.531-2.123 2.12-.53-.532zM4.64 14.55l2.898-.777.194.725-2.898.777-.194-.725z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcUnlink;
